export function getApiBaseUrl(): string {
  const url = import.meta.env.VITE_API_BASE_URL;
  if (!url) {
    throw new Error("VITE_API_BASE_URL must be set at build time");
  }
  return url;
}

export const PHOTOS_HOST: string =
  (import.meta.env.VITE_PHOTOS_HOST as string | undefined) ?? "photos.recipevault.ca";
